<template>
  <vuex-table :fields="fields" table_store="db/groups/table">
    <template slot="name" slot-scope="{ item }">
      <editable-name
        :id="item.id"
        :value="item.name"
        :is_edit="is_edit(item.id)"
        :from_first_page="true"
        @on-complete="cancel_edit()"
      >
        <template slot="default" slot-scope="{ value }">
          {{ value }}
        </template>
      </editable-name>
    </template>
    <template slot="actions" slot-scope="{ item }">
      <table-dropdown>
        <span class="dropdown-item-icon dropdown-item-icon--config" @click="start_edit(item.id)">
          {{ $t('shared.component.table.action.edit') }}
        </span>

        <span class="dropdown-item-icon dropdown-item-icon--trash" @click="remove(item)">
          {{ $t('shared.component.table.action.delete') }}
        </span>
      </table-dropdown>
    </template>
  </vuex-table>
</template>

<script>
  import EditableName from '@db/components/db-groups/db-groups-editable-name';
  import { EditableTaleField } from '@shared/mixins/editable-table-field';
  import { GroupModalService } from '@db/modals/GroupModalService';
  import { mapActions } from 'vuex';

  export default {
    components: { EditableName },
    mixins: [EditableTaleField],
    computed: {
      fields: function() {
        return [
          {
            key: 'name',
            label: this.$t('shared.component.table.field.name'),
            sortable: true,
            class: 'w-50'
          },

          {
            key: 'database_count',
            label: this.$t('db.group.field.databases_count'),
            sortable: false,
            class: 'w-50'
          },

          {
            key: 'created_at',
            label: this.$t('shared.component.table.field.created_at'),
            sortable: true,
            class: 'table-created_at'
          },

          {
            key: 'actions',
            label: this.$t('shared.component.table.actions'),
            sortable: false,
            class: 'table-actions'
          }
        ];
      }
    },

    methods: {
      ...mapActions('db/groups/table', ['getAsyncData']),

      remove: function(item) {
        GroupModalService.remove(item.id, item).on('success', () => this.getAsyncData({ current_page: 1 }));
      }
    }
  };
</script>
